module.exports = "/_next/static/images/29611d4d128898e726ff6cc3329ddd18-Nubank_HickDuarte_58654 (2) 1_xs.jpg";